import axios from 'axios';

const VendorContactService = {
  async createVendorContact({ formValues, vendorId }) {
    const response = await axios.post('/vendor_contact', {
      ...formValues,
      vendor_id: vendorId,
    });

    return response.data;
  },

  async getVendorContacts(vendorId) {
    const response = await axios.get(`/vendor/${vendorId}/vendor_contacts`);

    return response.data;
  },

  async getVendorContact(contactId) {
    const response = await axios.get(`/vendor_contact/${contactId}`);

    return response.data;
  },

  async updateVendorContact({ formValues, contactId }) {
    const response = await axios.put(
      `/vendor_contact/${contactId}`,
      formValues
    );

    return response.data;
  },

  async deleteVendorContact(contactId) {
    const response = await axios.delete(`/vendor_contact/${contactId}`);

    return response.data;
  },
};

export default VendorContactService;
